module.exports = new __parcel__URL__("Frame.3f96fd66.svg").toString();